import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stepper-save',
  templateUrl: './stepper-save.component.html',
  styleUrls: ['./stepper-save.component.css']
})
export class StepperSaveComponent {
  @Input() tabToSelect: string;
  @Output() tabBtnClick = new EventEmitter<number>();

  selectedTabIndex: number = 0;
  historyState: any;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.historyState = history.state;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tabToSelect && changes.tabToSelect.currentValue) {
      this.updateSelectedTab(changes.tabToSelect.currentValue);
    }
  }

  updateSelectedTab(tabName: string): void {
    switch (tabName) {
      case 'Listing Details':
        this.selectedTabIndex = 0;
        break;
      case 'Photos':
        this.selectedTabIndex = 1;
        break;
      default:
        this.selectedTabIndex = 0; // Default to the first tab if no match
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.tabBtnClick.emit(event.index);
  }

}
